import { Routes } from "@angular/router";
import { AdminModule } from "./admin/admin.module";
import { CartComponent } from "./cart/cart.component";
import { HomeComponent } from "./home/home.component";
import { OrdersComponent } from "./orders/orders.component";
import { QuotationsComponent } from "./quotations/quotations.component";
import { ShipmentModule } from "./shipment/shipment.module";
import { TrackingComponent } from "./tracking/tracking.component";
import { ToSignComponent } from "./to-sign/to-sign.component";

export const PagesRoutes: Routes = [
  {
    path: "",
    children: [
      {
        path: "dashboard",
        component: HomeComponent,
        data: {
          title: "Dashboard",
          description: "Visualizza un riepilogo dei servizi che usi",
          urls: [{ title: "Dashboard", url: "/dashboard" }, { title: "Dashboard" }]
        }
      },
      {
        path: "ordini",
        component: OrdersComponent,
        data: {
          title: "Ordini",
          description: "Vengono caricati gli ordini confermati degli ultimi 60 giorni. Filtrare la ricerca per impostare un arco temporale maggiore.",
          additionalDescription:"N.B. il preventivo di spesa è da considerarsi IVA esclusa e puramente indicativo, fa fede la fattura del vettore.",
          urls: [{ title: "Ordini", url: "/ordini" }, { title: "Ordini" }]
        }
      },
      {
        path: "tracking",
        component: TrackingComponent,
        data: {
          title: "Stato delle spedizioni",
          description:
            "Vengono caricate le spedizioni degli ultimi 60 giorni. Filtrare la ricerca per impostare un arco temporale maggiore.",
          urls: [
            { title: "Stato delle spedizioni", url: "/tracking" },
            { title: "Stato delle spedizioni" }
          ]
        }
      },
      {
        path: "nuova-spedizione",
        loadChildren: () => ShipmentModule
      },
      {
        path: "preventivi",
        component: QuotationsComponent,
        data: {
          title: "Preventivi",
          description:
            "Qui trovi l'elenco dei preventivi che devono essere approvati dagli utenti abilitati come Approvatori, i preventivi non potranno più essere approvati dopo 30 giorni dalla loro creazione.",
          urls: [{ title: "Preventivi", url: "/cart" }, { title: "Preventivi" }]
        }
      },
      {
        path: "da firmare",
        component: ToSignComponent,
        data: {
          title: "Da firmare",
          description:
            "Qui trovi l'elenco degli ordini con documenti ancora in attesa di firma digitale.",
          urls: [{ title: "Da firmare", url: "/cart" }, { title: "Da firmare" }]
        }
      },
      {
        path: "carrello",
        component: CartComponent,
        data: {
          title: "Carrello",
          description: "Gli ordini nel carrello sono validi fino a 30 giorni dalla loro creazione.",
          urls: [{ title: "Carrello", url: "/cart" }, { title: "Carrello" }]
        }
      },
      {
        path: "amministrazione",
        loadChildren: () => AdminModule
      },
      {
        path: "Tracking",
        redirectTo: "tracking",
        pathMatch: "full"
      },
      {
        path: "",
        pathMatch: "full",
        redirectTo: "dashboard"
      }
    ]
  }
];
